import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-md mx-auto lg:mx-0 mb-6">
              {appData.desc}
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line" />
                Android 版
              </button>
              <button className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line" />
                iOS 版
              </button>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 bg-background-50 rounded-2xl border border-background-200 p-4 flex items-center justify-center">
              <img
                src={appData.qrUrl}
                alt="黑料吃瓜在线移动端二维码"
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-xs text-center text-foreground-400 mt-3">扫码访问移动版</p>
          </div>
        </div>
      </div>
    </section>
  );
}